import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { laborPayStatusLabel } from "@/lib/manufacturing/laborPayList";
import type { LaborPayWeekBill } from "@/lib/manufacturing/laborPayWeekBill";

function money(n: number): string {
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

function when(d: Date): string {
  return d.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function ManufacturingLaborPayWeekSummary({
  bill,
  showingAll,
  onShowWeek,
  onShowAll,
}: {
  bill: LaborPayWeekBill;
  showingAll: boolean;
  onShowWeek: () => void;
  onShowAll: () => void;
}) {
  return (
    <div className="mb-3 rounded border border-gray-200 px-3 py-2 text-sm dark:border-zinc-700">
      <div className="font-medium text-gray-900 dark:text-zinc-100">
        This week · {when(bill.start)} – {when(bill.end)}
      </div>
      <div className="mt-1 text-gray-800 dark:text-zinc-200">
        {bill.buildings} {bill.buildings === 1 ? "building" : "buildings"} · {money(bill.totalUsd)} ·{" "}
        {bill.exceptions} {bill.exceptions === 1 ? "exception" : "exceptions"}
      </div>
      {bill.statusCounts.length > 0 ? (
        <div className="mt-1 text-xs text-gray-600 dark:text-zinc-400">
          {bill.statusCounts.map((item) => `${laborPayStatusLabel(item.status)} ${item.count}`).join(" · ")}
        </div>
      ) : null}
      <div className="mt-1 text-xs text-gray-700 dark:text-zinc-300">{bill.nextAction}</div>
      {bill.earlierOpen > 0 ? (
        <div className="mt-1 text-xs text-gray-600 dark:text-zinc-400">
          {bill.earlierOpen} earlier {bill.earlierOpen === 1 ? "invoice is" : "invoices are"} still open.
        </div>
      ) : null}
      <div className="mt-2 flex flex-wrap gap-2">
        <button type="button" className={ghostBtnClass} disabled={!showingAll} onClick={onShowWeek}>
          This week
        </button>
        <button type="button" className={ghostBtnClass} disabled={showingAll} onClick={onShowAll}>
          All invoices
        </button>
      </div>
    </div>
  );
}
